import { useContext } from 'react';
import PublicFormContext from '../contexts/publicForm.context';

export default function usePublicForm() {
  return useContext(PublicFormContext);
}
